@if (page$ | async; as page) {
    @if (page.error) {
        <main class="container py-4">
            <button type="button" class="btn btn-outline-secondary mb-4" (click)="back()">Back to menu</button>
            <h1 class="h4">Unable to load your menu choices</h1>
            <p role="alert">Please return to the menu and try again.</p>
        </main>
    } @else {
        <app-cover-choices-edit
            [venue]="page.venue" [menu]="page.menu" [productLibrary]="page.library"
            [bookingId]="page.details.bookingId" [docket]="page.docket" [partySize]="page.details.partySize"
            [coverIndex]="page.coverIndex" [prefilledName]="page.name"
            [canEditAfterSubmit]="!individual"
            (saved)="back()" (cancelled)="back()"
        ></app-cover-choices-edit>
    }
} @else {
    <div class="d-flex h-100 align-items-center justify-content-center gap-3" role="status">
        <span class="spinner-border" aria-hidden="true"></span>Loading menu…
    </div>
}
